import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=71c1d516&lang=pug&"
import script from "./SideMenu.vue?vue&type=script&lang=ts&"
export * from "./SideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c1d516')) {
      api.createRecord('71c1d516', component.options)
    } else {
      api.reload('71c1d516', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=71c1d516&lang=pug&", function () {
      api.rerender('71c1d516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "shared-components/SideMenu.vue"
export default component.exports